import React from "react";

export type GdPlaceholderVariant = "phone" | "devices" | "screen" | "wide" | "phones-dual" | "card";

interface GdImagePlaceholderProps {
  label: string;
  hint?: string;
  variant?: GdPlaceholderVariant;
  className?: string;
}

const PlaceholderIcon: React.FC<{ variant: GdPlaceholderVariant }> = ({ variant }) => {
  if (variant === "devices" || variant === "phones-dual") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="4" y="12" width="28" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <rect x="28" y="8" width="12" height="24" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <rect x="34" y="10" width="12" height="24" rx="2" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
      </svg>
    );
  }

  if (variant === "phone") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="14" y="4" width="20" height="40" rx="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M20 38h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (variant === "card") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="6" y="10" width="36" height="28" rx="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M6 22h36" stroke="currentColor" strokeWidth="1.5" />
        <rect x="10" y="28" width="20" height="3" rx="1" fill="currentColor" opacity="0.3" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <rect x="4" y="10" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 18h40" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12" cy="14" r="2" fill="currentColor" />
    </svg>
  );
};

const GdImagePlaceholder: React.FC<GdImagePlaceholderProps> = ({
  label,
  hint,
  variant = "screen",
  className = "",
}) => (
  <div
    className={`gd-placeholder gd-placeholder--${variant} ${className}`.trim()}
    role="img"
    aria-label={`${label}${hint ? ` — ${hint}` : ""}`}
  >
    <div className="gd-placeholder__frame">
      <span className="gd-placeholder__icon">
        <PlaceholderIcon variant={variant} />
      </span>
      <span className="gd-placeholder__label">{label}</span>
      {hint && <span className="gd-placeholder__hint">{hint}</span>}
    </div>
  </div>
);

export default GdImagePlaceholder;
